var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnSearchGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 11.5933 16.1979 13.0578 15.2746 14.2124L20.5301 19.4649C20.8231 19.7577 20.8233 20.2326 20.5305 20.5256C20.2644 20.792 19.8477 20.8163 19.554 20.5986L19.4699 20.526L14.2124 15.2746C13.0578 16.1979 11.5933 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10C3.25 6.27208 6.27208 3.25 10 3.25ZM10 4.75C7.10051 4.75 4.75 7.10051 4.75 10C4.75 12.8995 7.10051 15.25 10 15.25C12.8995 15.25 15.25 12.8995 15.25 10C15.25 7.10051 12.8995 4.75 10 4.75Z",
    fill: "#24C062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSearchGreen);
export default __webpack_public_path__ + "static/media/icn_search_green.3671312978e258b98f7c70fd6274f042.svg";
export { ForwardRef as ReactComponent };